import { render } from "./limits-dialog.vue?vue&type=template&id=8fdf1f64&ts=true"
import script from "./limits-dialog.vue?vue&type=script&lang=ts"
export * from "./limits-dialog.vue?vue&type=script&lang=ts"

import "./limits-dialog.vue?vue&type=style&index=0&id=8fdf1f64&lang=scss"

import exportComponent from "/Users/star/Desktop/clz-frontend/taxi-admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__